"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M47 22H11.029L26.121 6.908a1 1 0 0 0 0-1.414L24.707 4.08a1 1 0 0 0-1.414 0L4.08 23.293a1 1 0 0 0 0 1.414L23.293 43.92a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.414L11.029 26H47a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1z" })
);

